import { CREATE_REFERENCE, CREATE_REFERENCE_FAILED, CREATE_REFERENCE_SUCCESS, GETALL_REFERENCES, GETALL_REFERENCES_FAILED, GETALL_REFERENCES_SUCCESS, UPDATE_REFERENCE, UPDATE_REFERENCE_FAILED, UPDATE_REFERENCE_SUCCESS, UPLOAD_REF_FILES, UPLOAD_REF_FILES_FAILED, UPLOAD_REF_FILES_SUCCESS, VIEW_REF_FILES, VIEW_REF_FILES_FAILED, VIEW_REF_FILES_SUCCESS, DOWNLOAD_REFERENCE, DOWNLOAD_REFERENCE_FAILED, DOWNLOAD_REFERENCE_SUCCESS } from "./ActionTypes";

const initialState = {
    loading: false,
    error: null,
    responseMsg: null,
    isSubmitted: false,
    referenceList: [],
    refFilesList:[]
}

const ReferenceReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETALL_REFERENCES:
        case CREATE_REFERENCE:
        case UPDATE_REFERENCE:
        case VIEW_REF_FILES:
        case UPLOAD_REF_FILES:
            return {
                ...state,
                loading: true,
                referenceList: [],
                refFilesList:[],
                isSubmitted: false,
                responseMsg: ""
            }
        case DOWNLOAD_REFERENCE:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case GETALL_REFERENCES_FAILED:
        case CREATE_REFERENCE_FAILED:
        case UPDATE_REFERENCE_FAILED:
        case VIEW_REF_FILES_FAILED:
        case UPLOAD_REF_FILES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                isSubmitted: false,
            }
        case DOWNLOAD_REFERENCE_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                isSubmitted: false,
            }

        case GETALL_REFERENCES_SUCCESS:

            const newList = Array.isArray(action.payload)? action.payload.map((data) => ({
                ...data,
                full_name: data.first_name + " " + data.last_name
              })):[];

            return {
                ...state,
                loading: false,
                referenceList: newList
            }
        case VIEW_REF_FILES_SUCCESS:{
            return{
                ...state,
                loading: false,
                refFilesList: action.payload
            }
        }
        case DOWNLOAD_REFERENCE_SUCCESS:
            return {
                ...state,
                loading: false,
                responseMsg: action.payload,
            }
        case CREATE_REFERENCE_SUCCESS:
        case UPDATE_REFERENCE_SUCCESS:
        case UPLOAD_REF_FILES_SUCCESS:
            return {
                ...state,
                loading: false,
                isSubmitted: true,
                responseMsg: action.payload
            }

        default:
            return state
    }
};

export default ReferenceReducer;